////ucits webinar registration form confirm email addres
$(function () {

    if ($(".register-form .ConfirmEmailAddress").length == 0) return;

    $('.register-form .Email, .register-form .ConfirmEmailAddress').on('change', function () {
        let emailAdress = $('.register-form .Email').val();
        let confirmEmailAddress = $('.register-form .ConfirmEmailAddress').val();
        if (emailAdress && confirmEmailAddress) {
            if (emailAdress.toLowerCase() === confirmEmailAddress.toLowerCase()) {
                console.log("Emails do match")
                $('.register-form .ConfirmEmailAddress').parent().find(".invalid-feedback .Form__Element__ValidationError").hide();
                $('.register-form button.FormSubmitButton').removeAttr("disabled");
            }
            else {
                $('.register-form .ConfirmEmailAddress').parent().find(".invalid-feedback .Form__Element__ValidationError").show().html("Email addresses don't match")
                $('.register-form button.FormSubmitButton').prop("disabled", true);
            }
        }
    });
})
